import constants from 'Constants';
import Cookies from 'js-cookie';


export function getCookie(name, attributes={}) {
  return Cookies.get(name, attributes);
}

export function setCookie(name, value, attributes={}) {
  if (!('expires' in attributes)) {
    attributes['expires'] = constants.COOKIE_EXPIRES_DAYS;
  }

  Cookies.set(name, value, attributes);
  return Cookies.get(name, attributes);
}

export function setSessionCookie(name, value, attributes={}) {
  Cookies.set(name, value, attributes);
  return Cookies.get(name, attributes);
}

export function getOrSetCookie(name, value, attributes={}) {
  const cookie = getCookie(name, attributes) || null;
  if (cookie) return cookie;

  if (!('expires' in attributes)) {
    attributes['expires'] = constants.COOKIE_EXPIRES_DAYS;
  }

  setCookie(name, value, attributes);
  return getCookie(name, attributes);
}

export function removeCookie(name, attributes={}) {
  Cookies.remove(name, attributes);
}

export function getCookieInt(cookieName) {
  let value = 0;

  try {
    value = parseInt(getCookie(cookieName)) || 0;
  } catch(e) {
    value = 0;
  }

  return value;
}

export function parseCookieJson(rawValue, defaultValue) {
  let value = defaultValue;
  if (rawValue) {
    try {
      value = JSON.parse(rawValue);
    } catch(e) {
      value = defaultValue;
    }
  }

  if (!rawValue) value = defaultValue;
  return value;
}
